// extracted by mini-css-extract-plugin
module.exports = {"ApplicationLogin":"style_ApplicationLogin__1JtjS"};